// import mockSchools from '../data/schools';
import axios from 'axios';
import { getCookie } from '../../mixins/cookies'
import CONSTANTS from '../../settings/constants';

/* eslint no-console: "off" */
const registerSchoolStatus = (appID, fcmToken) => {
  return new Promise(function(resolve) {
    let registerApi = `${CONSTANTS.SCHOOL_STATUS}/register`

    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${registerApi}`)
    let start = Date.now()

    let data = {
      'platform': 'ParentApp',
      'pushToken': fcmToken
    }

    let config = {
      headers: {
        'token': appID
      }
    }

    //eslint-disable-next-line
    NativeJS.debugLog(`Payload data for ${registerApi}: ${JSON.stringify(data, null, 2)}`)

    //eslint-disable-next-line
    NativeJS.debugLog(`Payload headers for ${registerApi}: ${JSON.stringify(config, null, 2)}`)

    axios.post(registerApi, data, config).then(response => {
      let end = Date.now()
      let time = (end - start) / 1000;
      //eslint-disable-next-line
      NativeJS.debugLog(`${registerApi} responded after ${time} seconds with a ${response.status} code`);
      //eslint-disable-next-line
      NativeJS.debugLog(`${registerApi} Response body: ${JSON.stringify(response.data, null, 2)}`)
      resolve(response.data)
    }).catch((error) => {
      //eslint-disable-next-line
      NativeJS.debugLog(`error calling ${registerApi}: ${JSON.stringify(error, null, 2)}`)
    })
  });
};

const registerApp = (appID) => {
  return new Promise(function(resolve) {
    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${CONSTANTS.EDPUSH_REGISTER}`)
    let start = Date.now()

    let fcmToken = getCookie('fcmToken');
    let pushNotificationsCookie = getCookie('pushNotifications');

    //eslint-disable-next-line
    NativeJS.debugLog(`fcmToken for ${CONSTANTS.EDPUSH_REGISTER}: ${fcmToken}`)

    if (fcmToken && appID && pushNotificationsCookie === 'true') {

      let data = {
        'appName': 'ParentApp',
        'deviceToken': fcmToken,
        'deviceType': 'Android',
        'disabledTopics': [],
        'meta': 'Parent Android App',
        'uuidToken': appID
      }

      let config = {
        headers: {
          'Content-Type': 'text/plain'
        }
      }

      //eslint-disable-next-line
      NativeJS.debugLog(`starting call ${CONSTANTS.EDPUSH_REGISTER} with ${JSON.stringify(data, null, 2)}`)

      axios.post(`${CONSTANTS.EDPUSH_REGISTER}`, data, config).then(response => {
        let end = Date.now()
        let time = (end - start) / 1000;
        //eslint-disable-next-line
        NativeJS.debugLog(`${CONSTANTS.EDPUSH_REGISTER} responded after ${time} seconds with a ${response.status} code`);
        //eslint-disable-next-line
        NativeJS.debugLog(`${CONSTANTS.EDPUSH_REGISTER} Response body: ${JSON.stringify(response.data, null, 2)}`)
        resolve(response.data)
      }).catch((error) => {
        //eslint-disable-next-line
        NativeJS.debugLog(`error calling ${CONSTANTS.EDPUSH_REGISTER}: ${JSON.stringify(error, null, 2)}`)
      })
    }
  });
};

const fetchUserData = (accessToken, retries) => {
  return new Promise(function(resolve) {
    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${CONSTANTS.FETCH_USER_DATA}`)
    let start = Date.now()

    //eslint-disable-next-line
    NativeJS.debugLog(`accessToken for ${CONSTANTS.FETCH_USER_DATA}: ${accessToken}`)

    let config = {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    }

    //eslint-disable-next-line
    NativeJS.debugLog(`starting call ${CONSTANTS.FETCH_USER_DATA} with ${JSON.stringify(config, null, 2)}`)

    axios.get(`${CONSTANTS.FETCH_USER_DATA}`, config).then(response => {
      let end = Date.now()
      let time = (end - start) / 1000;
      //eslint-disable-next-line
      NativeJS.debugLog(`${CONSTANTS.FETCH_USER_DATA} responded after ${time} seconds with a ${response.status} code`);
      //eslint-disable-next-line
      NativeJS.debugLog(`${CONSTANTS.FETCH_USER_DATA} Response body: ${JSON.stringify(response.data, null, 2)}`)
      resolve(response.data)
    }).catch((error) => {
      if (error.response.status == 401 && error.response.data.error === 'invalid_token' && retries < 5) {
        //eslint-disable-next-line
        NativeJS.refreshToken()
        resolve('retry')
      } else {
        //eslint-disable-next-line
        NativeJS.debugLog(`error calling ${CONSTANTS.FETCH_USER_DATA}: ${JSON.stringify(error, null, 2)}`)
        resolve('error')
      }
    })
  });
};


export default { registerSchoolStatus, registerApp, fetchUserData }
